const isHourInUse = (hour: number, start: number, finish: number) => {
  if (start > finish) {
    return hour >= start || hour < finish;
  }
  return hour >= start && hour < finish;
};

export default isHourInUse;
